<template>
  <div class="gmf-color-pill">
    <div
      class="gmf-color-pill-fill"
      :style="computedStyle"
      >
        <template v-if="computedColors.length && computedColors.length > 1">
        <div v-for="(color, index) in computedColors" :key="index" :style="subColorStyle(index)" class="gmf-color-selector-sub-color" />
        </template>
    </div>
  </div>
</template>
<style>
.gmf-color-pill {
  position: relative;
  height: 100%;
  width: 100%;
}

.gmf-color-pill-fill {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.gmf-color-selector-sub-color:first-of-type {
  margin-top: -7%;
  height: 43%;
}


.gmf-color-selector-sub-color:last-of-type {
  margin-bottom: -7%;
  height: 43%;
}

.gmf-color-selector-sub-color {
  height: 33%;
  width: 150%;
  margin-left: -25%;
  flex-grow: 1;
  margin-top: -1px;
}
</style>
<script>
export default {
  props: {
    colors: {
      Type: [
        Array, //eg ["#ffffff", "#ff0000"]
        Object, // {partColor1: "#ff0000", partColor2: "#00ff00", partColor3: "#0000ff"}
        // { colors: [array of hex colors], iconColors: [array of hex colors] }
        String // a single hex color string, or comma seperated hex string
      ], 
    },
    default: [],
  },
  methods: {
    subColorStyle (index) {
      return { backgroundColor: this.computedColors[index] };
    }
  },
  computed: {
    computedColors () {
      if (Array.isArray(this.colors)) {
        return this.colors;
      } else if (typeof this.colors === 'object') { 
        if (this.colors.colors || this.colors.iconColors) {
          // If there are icon colors then display them, otherwise display the first color.
          return this.colors.iconColors?.length > 0 ? this.colors.iconColors : [this.colors.colors[0]];
        }

        if (this.colors.partColor1) {
          // Only display the first part color.
          return [this.colors.partColor1];
        }
      } else if (typeof this.colors === 'string') {
        return [...this.colors.split(',')];
      }
      return [];
    },
    computedStyle () {
      let style = {};
      if (this.computedColors.length > 1) {
        style = { transform: "rotateZ(-20deg)" };
      } else if (this.computedColors.length === 1) {
        style = { backgroundColor: this.computedColors[0] };
      }
      return style;
    },
  },
};
</script>